import { graphql, StaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

const style = {
  height: '32px',
  width: '32px',
};

export default () => (
  <StaticQuery
    query={graphql`
      query thumbnailQueryAndThumbnailQuery {
        thumbnail: file(
          sourceInstanceName: { eq: "images" }
          relativePath: { eq: "juvoni-thumbnail.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 100, width: 32, layout: FIXED, formats: [AUTO, WEBP])
          }
        }
      }
    `}
    render={(data) => (
      <GatsbyImage
        image={data.thumbnail.childImageSharp.gatsbyImageData}
        className="rounded-full"
        alt="Juvoni"
        style={style}
      />
    )}
  />
);
